import {
  useInspectionDamagesImages,
  useDeleteInspectionDamagesImages,
} from '@/api/Inspections';
import { useAppCustomers } from '@/hooks';
import { useTranslate } from '@/translations';
import { faAdd, GalleryImages, Icon } from '@/ui/components';
import { ReplaceImageType } from '@/utils/constants';
import { Button, Card, Spin } from 'antd';
import React, { useState, useCallback } from 'react';
import { AddImagePopup } from '../AddImagePopup';

interface DamageImagesProps {
  damageDetailId: number;
  disabled?: boolean;
}
export const DamageImages = ({
  damageDetailId,
  disabled,
}: DamageImagesProps) => {
  const { t } = useTranslate();
  const { hasSuperAdminAccess } = useAppCustomers();

  const {
    data: damageImagesData,
    isFetching: isDamagesImagesLoading,
    refetch: refechImages,
  } = useInspectionDamagesImages(damageDetailId);
  const { mutate: deleteDamagesImagesMutate, isPending: isDeleteLoading } =
    useDeleteInspectionDamagesImages();

  const isLoading = isDamagesImagesLoading || isDeleteLoading;

  const [isImagePopupVisible, setImagePopupVisibility] = useState(false);

  const toggleImagePopup = useCallback(() => {
    setImagePopupVisibility(!isImagePopupVisible);
  }, [isImagePopupVisible]);

  return (
    <>
      <AddImagePopup
        isPopupVisible={isImagePopupVisible}
        onTogglePopup={toggleImagePopup}
        vehicleDamageId={damageDetailId}
      />
      <Spin spinning={isLoading}>
        <Card>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="m-0 text-uppercase">{t('images')}</h6>
            {!disabled ? (
              <div className="d-flex justify-content-end">
                <Button onClick={toggleImagePopup}>
                  <Icon icon={faAdd} />
                  Add Images
                </Button>
              </div>
            ) : null}
          </div>

          <GalleryImages
            images={
              damageImagesData?.entities.map((image) => ({
                id: image.id,
                type: ReplaceImageType.DamageImage,
                imageFileUrl: image.imageFileUrl,
                thumbnailImageUrl: image.resizedImageUrl,
              })) || []
            }
            actions={{
              replaceImage:
                hasSuperAdminAccess && !disabled
                  ? () => refechImages()
                  : undefined,
              onDelete: !disabled
                ? (id) => deleteDamagesImagesMutate(id)
                : undefined,
            }}
          />
        </Card>
      </Spin>
    </>
  );
};
